import {DashboardRoutesPaths} from '../../routes/routes-paths/dashboard.routes-paths';
import {RoutesParts} from '../../constants/routes-parts';

export const DepositRoutesPaths = {
  PARTNER_DEPOSIT_AMOUNT: DashboardRoutesPaths.DEPOSIT + RoutesParts.AMOUNT,
  PARTNER_DEPOSIT_REFERENCE_NUMBER: DashboardRoutesPaths.DEPOSIT + RoutesParts.REFERENCE_NUMBER,
  PARTNER_DEPOSIT_REFERENCE_NUMBER_CANCEL: DashboardRoutesPaths.DEPOSIT + RoutesParts.REFERENCE_NUMBER + RoutesParts.CANCEL
};
